import {getConfig} from '../../config';
const CONFIG = getConfig();

export const REQUEST_METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};

export const ENDPOINTS_CONST = {
    WATCHLIST_API: {
      GET: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/marketwatch/api/v1/watchlist`,
      },
      CREATE: {
        method: REQUEST_METHODS.POST,
        endpoint: () => `${CONFIG.DATA}/marketwatch/api/v1/watchlist`,
      },
      RENAME: {
        method: REQUEST_METHODS.PUT,
        endpoint: (id) => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/${id}/rename`,
      },
      DELETE: {
        method: REQUEST_METHODS.DELETE,
        endpoint: (id) => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/${id}`,
      },
      REORDER: {
        method: REQUEST_METHODS.PUT,
        endpoint: () => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/reorder`,
      },
      REORDER_SECURITIES: {
        method: REQUEST_METHODS.PUT,
        endpoint: (id) => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/${id}/security/reorder`,
      },
      GET_STOCKS: {
        method: REQUEST_METHODS.GET,
        endpoint: (id) => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/${id}/security`,
      },
      ADD_STOCK: {
        method: REQUEST_METHODS.POST,
        endpoint: (id) => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/${id}/security`,
      },
      DELETE_STOCK: {
        method: REQUEST_METHODS.DELETE,
        endpoint: (id, securityId) => `${CONFIG.DATA}/marketwatch/api/v1/watchlist/${id}/security/${securityId}`,
      },
    },
    LOGOUT: {
      method: REQUEST_METHODS.GET,
      endpoint: () => `${CONFIG.AUTH}/api/auth/logout`,
    },
    ORDERS: {
      VIEW_ORDERS: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.ORDERS}/order/info/v1/orderbook`,
      },
      GET_PAST_ORDERS: {
        method: REQUEST_METHODS.GET,
        endpoint: ({from_created_date, to_created_date, page_num, page_size}) => `${CONFIG.DATA}/order/info/past/v2/search?from_created_date=${from_created_date}&to_created_date=${to_created_date}&page_num=${page_num}&page_size=${page_size}`,
      },
      MARGIN_REQUIRED: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/margin/calculator/api/v1/order`,
      },
    },
    HOLDINGS: {
      ALL: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/holdings/v1/get-user-holdings-data`,
      },
    },
    POSITIONS: {
      GET: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.ORDERS}/order/info/v1/position`,
      },
    },
    GET_DETAILS_BY_ISIN: {
      method: REQUEST_METHODS.GET,
      endpoint: (id) => `${CONFIG.DATA}/data/v2/isin-pml-details?isins=${id}`,
    },
    FUNDS: {
      GET_SUMMARY: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/fms/api/v5/funds/summary`,
      },
    },
    ACCOUNT: {
      GET_USER_DATA: {
        method: REQUEST_METHODS.GET,
        endpoint: (id) => `${CONFIG.PROFILE}/pm/api/v1/users/${id}`,
      },
      EXIT: {
        COVER: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/exit/cover`,
        },
        BRACKET: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/exit/bracket`,
        },
      },
    },
    ORDER: {
      PLACE: {
        REGULAR: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v2/place/regular`,
        },
        BRACKET: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/place/bracket`,
        },
        COVER: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/place/cover`,
        },
      },
      CANCEL: {
        method: REQUEST_METHODS.POST,
        endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/cancel/regular`,
      },
      EXIT: {
        COVER: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/exit/cover`,
        },
        BRACKET: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/exit/bracket`,
        },
      },
      MODIFY: {
        REGULAR: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v2/modify/regular`,
        },
        BRACKET: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/modify/bracket`,
        },
        COVER: {
          method: REQUEST_METHODS.POST,
          endpoint: () => `${CONFIG.ORDERS}/order/txn/v1/modify/cover`,
        },
      },
      CHARGES: {
        method: REQUEST_METHODS.POST,
        endpoint: () => `${CONFIG.DATA}/fms/api/v1/charges/info`,
      },
    },
    COMPANY: {
      GET_DETAILS_BY_ISIN: {
        method: REQUEST_METHODS.GET,
        endpoint: (id) => `${CONFIG.DATA}/data/v2/isin-pml-details?isins=${id}`,
      },
      GET_DETAILS_BY_SYMBOL: {
        method: REQUEST_METHODS.POST,
        endpoint: () => `${CONFIG.DATA}/data/v2/symbol-pml-details`,
      },
      GET_DETAILS_BY_SECURITY_ID: {
        method: REQUEST_METHODS.GET,
        endpoint: (secId, exchange, segment) => `${CONFIG.DATA}/data/v2/secid-x-pml-details?sec-id=${secId}&x=${exchange}&s=${segment}`,
      },
      GET_INVESTCARE_NUDGE: {
        method: REQUEST_METHODS.GET,
        endpoint: (scrip_id, segment, exchange, isin) => `${CONFIG.DATA}/nudge-info/api/v3/scrip?scrip_id=${scrip_id}&segment=${segment}&exchange=${exchange}${isin ? `&isin=${isin}`: ''}`,
      },
    },
    MARKET_STATUS: {
      GET: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/exchange/mkt/v2/status`,
      },
    },
    USER_DETAILS: {
      GET_SUBSCRIPTIONS: {
        method: REQUEST_METHODS.GET,
        endpoint: (customerId) => `${CONFIG.PLATFORM}/subscription/v4/get-current-plan/${customerId}`,
      },
    },
    EDIS_AUTH: {
      UPDATE_STATUS: {
        method: REQUEST_METHODS.GET,
        endpoint: (id) => `${CONFIG.DATA}/edis/authorization/api/v2/status/${id}`,
      },
    },
    LOG_ERROR: {
      method: REQUEST_METHODS.POST,
      endpoint: () => `${CONFIG.LOGGER}/logger/log`,
    },
    GET_READINESS_DATA: {
      method: REQUEST_METHODS.GET,
      endpoint: (id) => `${CONFIG.PLATFORM}/userprofile/user/${id}/v3/readiness?product=EQUITY`,
    },
    STOREFRONT_DATA: {
      method: REQUEST_METHODS.POST,
      endpoint: () => `${CONFIG.STOREFRONT}`,
    },
    SLEEK_CARD: {
      method: REQUEST_METHODS.GET,
      endpoint: () => `${CONFIG.BASE}/aggr/equity/v1/popup`,
    },
    BASKET_ORDERS: {
      GET_LIST: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/basket-order/api/v1/baskets`,
      },
      CREATE_BASKET: {
        method: REQUEST_METHODS.POST,
        endpoint: () => `${CONFIG.DATA}/basket-order/api/v1/create/basket`,
      },
      DELETE_BASKET: {
        method: REQUEST_METHODS.POST,
        endpoint: () => `${CONFIG.DATA}/basket-order/api/v1/delete/baskets`,
      },
      MODIFY_BASKET: {
        method: REQUEST_METHODS.PUT,
        endpoint: (basket_id) => `${CONFIG.DATA}/basket-order/api/v1/modify/basket/${basket_id}`,
      },
      GET_ORDERS: {
        method: REQUEST_METHODS.GET,
        endpoint: (basketId) => `${CONFIG.DATA}/basket-order/api/v1/basket/${basketId}`,
      },
      ADD_ORDER: {
        method: REQUEST_METHODS.POST,
        endpoint: (basketId) => `${CONFIG.DATA}/basket-order/api/v1/add/order/${basketId}`,
      },
      DELETE_ORDER: {
        method: REQUEST_METHODS.DELETE,
        endpoint: (basket_id, order_id) => `${CONFIG.DATA}/basket-order/api/v1/delete/order/${basket_id}/${order_id}`,
      },
      MODIFY_ORDER: {
        method: REQUEST_METHODS.PUT,
        endpoint: (basket_id, order_id) => `${CONFIG.DATA}/basket-order/api/v1/modify/order/${basket_id}/${order_id}`,
      },
    },
    UNDERLYING_FNO: {
      GET_INDICES: {
        method: REQUEST_METHODS.GET,
        endpoint: () => `${CONFIG.DATA}/data/v1/indices`,
      },
    },
    OPTION_CHAIN: {
      FNO_OPTIONS_CONFIG: {
        method: REQUEST_METHODS.GET,
        endpoint: (symbol) => `${CONFIG.DATA}/fno/dashboard/api/v1/option-chain/config?symbol=${symbol}`,
      },
      FNO_OPTIONS: {
        method: REQUEST_METHODS.GET,
        endpoint: (symbol, expiry, type) => `${CONFIG.DATA}/fno/dashboard/api/v1/option-chain?symbol=${symbol}&expiry=${expiry}&type=${type}`,
      },
      FNO_TRENDS_INDICATOR: {
        method: REQUEST_METHODS.GET,
        endpoint: (symbol, expiry) => `${CONFIG.DATA}/fno/dashboard/api/v1/futures/builtup?symbol=${symbol}&size=1`,
      },
    },
}
